<span>{{text}}</span>

@if(class == 'complete'){
	<mat-icon [inline]="true">check</mat-icon>
}
